import React, { useEffect } from "react";
import { Card, CardBody, Input, Label } from "reactstrap";

export const TieredPricingInput = ({ capacity, basePrice, tiers, setTiers,setBasePrice,col,isSold,oldCapacity }) => {
    useEffect(() => {
      const newTiers = [];
      for (let i = 1; i <= capacity; i++) {
        const existing = tiers.find((t) => t.players === i);
        newTiers.push({
          players: i,
          price: i === 1 ? basePrice : (existing ? existing.price : 0),
        });
      }
      setTiers(newTiers);
    }, [capacity, basePrice]);

  const handleChange = (index, value) => {
    const updated = [...tiers];
    const numValue = parseFloat(value) || 0;
    updated[index].price = numValue;
    setTiers(updated);
    if (updated[index].players === 1) {
      setBasePrice(numValue);
    }
  };
  return (
    <Card className="border-0 shadow-sm" style={{ background: '#f8f9fa' }}>
      <CardBody className="p-4">
        <div className="mb-3">
          <h6 className="ctf-tx-primary mb-1" style={{ fontWeight: 600 }}>
            <i className="bi bi-graph-up-arrow mr-2"></i>
            Price Configuration
          </h6>
          <small className="text-muted">Set custom prices for each player count</small>
        </div>
        <div className="row g-3">
          {tiers?.map((tier, idx) => (
            <div key={idx} className={`col-md-6 col-lg-${col?col:4}`}>
              <div className="p-3 bg-white rounded border" style={{ transition: 'all 0.2s' }}>
                <Label className="text-secondary mb-2 d-block" style={{ fontSize: '0.875rem', fontWeight: 500 }}>
                  <i className="bi bi-people-fill mr-2 ctf-tx-primary"></i>
                  {tier.players} Player{tier.players > 1 ? "s" : ""}
                </Label>
                <div className="input-group">
                  <Input
                    type="number"
                    min={0}
                    step="0.01"
                    value={tier.price}
                    onChange={(e) => handleChange(idx, e.target.value)}
                    className="border-start-0"
                    style={{ fontSize: '1rem', fontWeight: 500 }}
                    disabled={isSold && idx <oldCapacity }
                  />
                   <span className="input-group-text bg-light border-end-0">{JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))?.currency||"$"}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};